import React from "react";
import { Anchor, Box, Stack, Text, rem } from "@mantine/core";
import { IconAlertTriangle, IconExternalLink } from "@tabler/icons-react";

interface DocsServiceNoticeProps {
  includeInvoiceDecoder?: boolean;
}

export default function DocsServiceNotice({
  includeInvoiceDecoder = false,
}: DocsServiceNoticeProps) {
  return (
    <Box
      role="note"
      aria-label="Rizful Node paid service notice"
      style={{
        position: "relative",
        overflow: "hidden",
        width: "100%",
        maxWidth: "calc(100vw - 2 * var(--mantine-spacing-lg))",
        boxSizing: "border-box",
        minHeight: rem(168),
        padding: "clamp(1.25rem, 3vw, 2rem)",
        borderRadius: "var(--mantine-radius-md)",
        border:
          "1px solid light-dark(var(--mantine-color-orange-4), rgba(255, 176, 0, 0.48))",
        background:
          "linear-gradient(135deg, light-dark(rgba(255, 243, 205, 0.84), rgba(255, 176, 0, 0.13)), light-dark(rgba(255, 248, 225, 0.64), rgba(20, 20, 20, 0.68)))",
        boxShadow: "0 16px 36px rgba(0, 0, 0, 0.18)",
      }}
    >
      <Box
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: "0 auto 0 0",
          width: rem(8),
          background:
            "linear-gradient(180deg, var(--mantine-color-orange-5), var(--mantine-color-yellow-4))",
        }}
      />
      <Box
        style={{
          display: "grid",
          gridTemplateColumns: `${rem(76)} minmax(0, 1fr)`,
          gap: "var(--mantine-spacing-xl)",
          position: "relative",
          paddingLeft: "var(--mantine-spacing-md)",
        }}
      >
        <Box
          aria-hidden="true"
          style={{
            alignItems: "center",
            background:
              "linear-gradient(135deg, var(--mantine-color-orange-5), var(--mantine-color-yellow-4))",
            borderRadius: "var(--mantine-radius-md)",
            boxShadow: "0 10px 26px rgba(245, 159, 0, 0.32)",
            color: "var(--mantine-color-dark-9)",
            display: "flex",
            flex: "0 0 auto",
            height: rem(76),
            justifyContent: "center",
            width: rem(76),
          }}
        >
          <IconAlertTriangle size={44} stroke={2.25} />
        </Box>
        <Stack gap="md" style={{ minWidth: 0 }}>
          <Stack gap={6}>
            <Text
              fw={800}
              size="xl"
              style={{
                lineHeight: 1.1,
                overflowWrap: "anywhere",
              }}
            >
              This is documentation for Rizful Node, our paid service.
            </Text>
            <Text
              size="lg"
              style={{
                lineHeight: 1.55,
                maxWidth: rem(760),
                overflowWrap: "anywhere",
              }}
            >
              For free Rizful.com features, see{" "}
              <Anchor href="/">
                the home page{" "}
                <IconExternalLink
                  size={16}
                  style={{ verticalAlign: "text-top" }}
                />
              </Anchor>
              .
            </Text>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
}
